import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Space,
  Input,
  Form,
  Breadcrumb,
  Collapse,
  Select,
  Checkbox,
  Modal,
} from "antd";
import {
  DoubleRightOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  AddPartnerClientApi,
  EditPartnerClientApi,
  GetPartnerClientByIdApi,
} from "../ClientsApi";
import { getPartnerTypeAPI } from "../../../CommonComponents/Lookup/LookupAPI";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import CountryCode from "CommonComponents/CountryCode";
import Address from "CommonComponents/Address";
import AddressType from "features/Enums/AddressType";

function AddPartnerClient(props) {
  const { Option } = Select;
  const { TextArea } = Input;
  const { Panel } = Collapse;
  const form = Form.useForm()[0];
  const dispatch = useDispatch();
  const { id } = useParams();
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const leadData = location.state || {};
  const client = useSelector((state) => state.clients.partnerClientById);
  const companies = useSelector((state) => state.lookup.companyNames);
  const partnerType = useSelector((state) => state.lookup.partnerType);
  const [sameAsCompany, setSameAsCompany] = useState(false);
  const [companyAddressId, setCompanyAddressId] = useState(null);
  const [billingAddressId, setBillingAddressId] = useState(null);
  const [activeKeys, setActiveKeys] = useState(["1"]);
  const [isFieldsEdited, setIsFieldsEdited] = useState(false);
  const selectedLanguage = localStorage.getItem("selectedlanguage");
  useEffect(() => {
    if (props.clientId) {
      dispatch(GetPartnerClientByIdApi(props.clientId));
    } else {
      setTimeout(() => {
        form.resetFields();
        setSameAsCompany(false);
        setActiveKeys(["1"]);
      });
    }
  }, [props.clientId]);

  useEffect(() => {
    dispatch(getPartnerTypeAPI());
  }, [dispatch]);

  useEffect(() => {
    if (client && Object.keys(client).length > 0) {
      if (Array.isArray(client?.address) && client?.address?.length > 0) {
        const addressList = client.address;
        const companyAddress =
          addressList.find(
            (addr) => addr.addressType === AddressType.CompanyAddress.id
          ) || {};
        const billingAddress =
          addressList.find(
            (addr) => addr.addressType === AddressType.BillingAddress.id
          ) || {};
        const additionalAddresses = addressList.filter(
          (addr) => addr.addressType === AddressType.AdditionalAddress.id
        );

        form.setFieldsValue({
          ...client,
          Company: companyAddress,
          Billing: billingAddress,
          address: additionalAddresses,
          isBillingAddressSame: client.isBillingAddressSame,
          mappedcompanyname:
            client.partnerClientCompanyMapping?.map((item) => item.companyId) ||
            [],
        });

        setSameAsCompany(client.isBillingAddressSame);
      } else {
        form.setFieldsValue(client);
        setSameAsCompany(client.isBillingAddressSame);
      }
    }
  }, [client, form]);

  const handleSubmit = async (formData) => {
    let addresses = [];
    if (Array.isArray(formData.address)) {
      addresses = formData.address.map((addr) => ({
        ...addr,
        isBilling: addr.isBilling || false,
        isCheckedSame: false,
        addressType: AddressType.AdditionalAddress.id,
      }));
    }
    if (formData.Company) {
      addresses.push({
        ...formData.Company,
        isBilling: false,
        isCheckedSame: sameAsCompany,
        addressType: AddressType.CompanyAddress.id,
      });
    }
    if (formData.Billing) {
      addresses.push({
        ...formData.Billing,
        isBilling: true,
        isCheckedSame: sameAsCompany,
        addressType: AddressType.BillingAddress.id,
      });
    }
    // const partnerClientCompanyMapping = (formData.mappedcompanyname || []).map(
    //   (companyId) => ({
    //     companyId,
    //   })
    // );
    const transformedData = {
      ...formData,
      isActive: formData.isActive ?? true,
      isBillingAddressSame: sameAsCompany,
      address: addresses,
      //partnerClientCompanyMapping,
    };
    if (props.clientId) {
      await Promise.all([
        dispatch(EditPartnerClientApi(transformedData, props.pagination)).then(
          (res) => {
            if (res) {
              oncancel();
            }
          }
        ),
      ]);
    } else {
      await Promise.all([
        dispatch(AddPartnerClientApi(transformedData, props.pagination)).then(
          (res) => {
            if (res) {
              oncancel();
            }
          }
        ),
      ]);
    }
  };
  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setSameAsCompany(isChecked);

    if (isChecked) {
      const companyAddress = form.getFieldValue("Company") || "";
      form.setFieldsValue({
        Billing: {
          address1: companyAddress.address1,
          address2: companyAddress.address2,
          city: companyAddress.city,
          provinceId: companyAddress.provinceId,
          zip: companyAddress.zip,
          countryId: companyAddress.countryId,
        },
        isBillingAddressSame: true,
      });
    } else {
      form.setFieldsValue({
        isBillingAddressSame: false,
      });
    }
  };
  const handleAddressChange = () => {
    if (sameAsCompany) {
      setSameAsCompany(false);
    }
  };
  const oncancel = () => {
    props.onClose();
    if (!props.clientId) {
      form.resetFields();
      setSameAsCompany(false);
      setActiveKeys(["1"]);
    }
  };
  const handlePanelChange = (keys) => {
    setActiveKeys(keys);
  };
  const handleFinishFailed = () => {
    setActiveKeys(["1", "2"]);
  };
  const onPopCancel = () => {
    Modal.confirm({
      title: intl.formatMessage({
        id: props.clientId
          ? "AddPartner.Popup.CancelEditPartnerClient"
          : "AddPartner.Popup.CancelAddPartnerClient",
      }),
      content: intl.formatMessage({
        id: "Common.PopConfirm",
      }),
      okText: intl.formatMessage({ id: "Common.Yes" }),
      cancelText: intl.formatMessage({ id: "Common.No" }),
      onOk: () => {
        oncancel();
      },
    });
  };
  return (
    <>
      <Form
        form={form}
        name="basic"
        layout="vertical"
        //initialValues={client}
        autoComplete="off"
        size="large"
        onFinish={handleSubmit}
        onFinishFailed={handleFinishFailed}
      >
        <Form.Item name="id" hidden={true}></Form.Item>
        <Form.Item name="createdBy" hidden={true}></Form.Item>
        <Form.Item name="createdDate" hidden={true}></Form.Item>
        <Collapse
          activeKey={activeKeys}
          onChange={handlePanelChange}
          size="small"
        >
          <Panel header={<FormattedMessage id="Common.BasicInfo" />} key="1">
            <Row gutter={16}>
              {/* <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="AddClient.MappedCompany" />}
                  name="mappedcompanyname"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "AddClient.error.PleaseSelectMappedComapany",
                      }),
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    placeholder={intl.formatMessage({
                      id: "AddClient.placeholder.Selectmappedcompany",
                    })}
                    style={{ width: "100%" }}
                    options={companies
                      .filter((c) => c.isActive)
                      .map((c) => ({
                        label: c.companyName,
                        value: c.id,
                      }))}
                  />
                </Form.Item>
              </Col> */}
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="AddClient.CompanyName" />}
                  name="companyName"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "AddClient.error.PleaseEnterComapanyName",
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "AddClient.placeholder.EnterCompanyName",
                    })}
                    maxLength={100}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={
                    <FormattedMessage id="PartnerCLient.Maincontactperson" />
                  }
                  name="contactPerson"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "PartnerCLient.error.PleaseEntermainContactPerson",
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "PartnerCLient.placeholder.EnterMainContactPerson",
                    })}
                    maxLength={50}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={
                    <FormattedMessage id="PartnerCLient.Maincontactmail" />
                  }
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "PartnerCLient.error.PleaseEntermaincontactmail",
                      }),
                    },
                    {
                      type: "email",
                      message: intl.formatMessage({
                        id: "Lead.Rule.Email",
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "PartnerCLient.placeholder.EnterMaincontactmail",
                    })}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={
                    <FormattedMessage id="PartnerCLient.Maincontactphonenumber" />
                  }
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "PartnerCLient.error.PleaseEntermaincontactphonenumber",
                      }),
                    },
                    {
                      pattern: /^[0-9]{10,11}$/,
                      message: intl.formatMessage({
                        id: "AddClient.error.Phonenumbermustbe10digits",
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "PartnerCLient.placeholder.EnterMaincontactphonenumber",
                    })}
                    addonBefore={<CountryCode name="countryCode" />}
                    style={{
                      width: "100%",
                    }}
                    maxLength={11}
                    type="tel"
                    value={form.getFieldValue("phone")}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      form.setFieldsValue({ phone: value });
                    }}
                    onPaste={(event) => {
                      const pasteData = event.clipboardData.getData("Text");
                      if (!/^\d+$/.test(pasteData)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="PartnerCLient.Creditlimit" />}
                  name="creditLimit"
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "PartnerCLient.placeholder.Entercreditlimit",
                    })}
                    maxLength={20}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      form.setFieldsValue({ creditLimit: value });
                    }}
                    onPaste={(e) => {
                      const pasteData = e.clipboardData.getData("Text");
                      if (!/^\d+$/.test(pasteData)) {
                        e.preventDefault();
                      }
                    }}
                    addonAfter="$"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="PartnerCLient.Typeofpartner" />}
                  name="typeId"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "PartnerCLient.error.Pleasselecttypeofpartner",
                      }),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder={intl.formatMessage({
                      id: "PartnerCLient.placeholder.Selecttypeofpartner",
                    })}
                    style={{ width: "100%" }}
                    optionFilterProp="children"
                    allowClear
                  >
                    {partnerType?.map((type) => {
                      const partnerTypeName =
                        selectedLanguage === "fr-FR"
                          ? type.nameFr
                          : type.nameEn;

                      return (
                        <Option
                          key={type.id}
                          value={type.id}
                          label={partnerTypeName}
                        >
                          {partnerTypeName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="PartnerCLient.Partnercorptel" />}
                  name="telePhone"
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "PartnerCLient.placeholder.Enterpartnercorptel",
                    })}
                    maxLength={20}
                    value={form.getFieldValue("telePhone")}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      form.setFieldsValue({ telePhone: value });
                    }}
                  />
                </Form.Item>
              </Col>
              {props?.clientId ? (
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Form.Item
                    label={<FormattedMessage id="AddClient.Status" />}
                    name="isActive"
                    rules={[{ required: true, message: "Status is required" }]}
                    initialValue={true}
                  >
                    <Select
                      showSearch
                      placeholder={intl.formatMessage({
                        id: "AddClient.placeholder.SelectStatus",
                      })}
                      optionFilterProp="children"
                      allowClear
                      filterOption={(input, option) => {
                        const text = intl.formatMessage({
                          id: option.value
                            ? "Common.Active"
                            : "Common.InActive",
                        });
                        return text.toLowerCase().includes(input.toLowerCase());
                      }}
                    >
                      <Select.Option value={true}>
                        {<FormattedMessage id="Common.Active" />}
                      </Select.Option>
                      <Select.Option value={false}>
                        {<FormattedMessage id="Common.InActive" />}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              ) : null}
              <Col span={24}>
                <h5 className="pb-10">
                  <FormattedMessage id="PartnerCLient.Partnercorpaddress" />
                </h5>
                <Address
                  className="mt-10"
                  prefix="Company"
                  onChange={handleAddressChange}
                  setCompanyAddressId={setCompanyAddressId}
                  setIsFieldsEdited={setIsFieldsEdited}
                  isValidationRequired={props?.isValidationRequired}
                />
              </Col>
            </Row>
          </Panel>
          <Panel
            header={<FormattedMessage id="Common.BillingInfo" />}
            key="2"
            forceRender
          >
            <Row gutter={16}>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={
                    <FormattedMessage id="PartnerCLient.Billingcontactperson" />
                  }
                  name="billingContactPerson"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: intl.formatMessage({
                  //       id: "PartnerCLient.error.PleaseEnterbillingContactPerson",
                  //     }),
                  //   },
                  // ]}
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "PartnerCLient.placeholder.Enterbillingcontactperson",
                    })}
                    maxLength={100}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={
                    <FormattedMessage id="PartnerCLient.Billingcontactmail" />
                  }
                  name="billingEmail"
                  rules={[
                    {
                      type: "email",
                      message: intl.formatMessage({
                        id: "PartnerCLient.error.PleaseEnterbillingContactmail",
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "PartnerCLient.placeholder.Enterbillingcontactmail",
                    })}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  label={
                    <FormattedMessage id="PartnerCLient.Billingcontactphonenumber" />
                  }
                  name="billingPhone"
                  rules={[
                    // {
                    //   required: true,
                    //   message: intl.formatMessage({
                    //     id: "PartnerCLient.error.PleaseEnterbillingContactphonenumber",
                    //   }),
                    // },
                    {
                      pattern: /^[0-9]{10,11}$/,
                      message: intl.formatMessage({
                        id: "AddClient.error.Phonenumbermustbe10digits",
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "PartnerCLient.placeholder.Enterbillingcontactphonenumber",
                    })}
                    addonBefore={<CountryCode name="billingCountryCode" />}
                    style={{
                      width: "100%",
                    }}
                    maxLength={11}
                    type="tel"
                    value={form.getFieldValue("billingPhone")}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      form.setFieldsValue({ billingPhone: value });
                    }}
                    onPaste={(event) => {
                      const pasteData = event.clipboardData.getData("Text");
                      if (!/^\d+$/.test(pasteData)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <h5 className="pb-10">
                  {<FormattedMessage id="AddClient.BillingAddress" />}
                </h5>
                <Checkbox
                  className="pb-10"
                  checked={sameAsCompany}
                  onChange={handleCheckboxChange}
                >
                  {<FormattedMessage id="AddClient.SameAsCompanyAddress" />}
                </Checkbox>
                <Address
                  className="mt-10"
                  prefix="Billing"
                  disabled={sameAsCompany}
                  setBillingAddressId={setBillingAddressId}
                  setIsFieldsEdited={setIsFieldsEdited}
                  isValidationRequired={props?.isValidationRequired}
                />
              </Col>
            </Row>
          </Panel>
        </Collapse>
        <Row gutter={16}>
          <Col span={24} className="text-center mt-10">
            <Space>
              <Button
                danger
                variant="outlined"
                size="medium"
                onClick={onPopCancel}
              >
                <CloseCircleOutlined />
                {<FormattedMessage id="AddClient.Cancel" />}
              </Button>
              <Button type="primary" size="medium" htmlType="submit">
                <CheckCircleOutlined />
                {props.clientId ? (
                  <FormattedMessage id="AddClient.SaveChanges" />
                ) : (
                  <FormattedMessage id="PartnerCLient.AddPartner" />
                )}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default AddPartnerClient;
